module.exports = __webpack_public_path__ + "media/images/store_badges/google_play/google_play_de-516952c65f223daa810170bb52dc6d68.png";